import { ComponentStatuses } from "../../../../src/component-statuses";
import * as React from 'react';
export default {
  ComponentStatuses,
  React
};